import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Ateco, CommonService } from '@shared/common.service';
import { AtecoUtente } from 'app/main/forfettario-folder/forfettario.models';
import { tap, take } from 'rxjs/operators';

export interface AtecoEditFormBuildOptions {
    dataInizioDisabled: boolean;
    dataFineDisabled: boolean;
}

@Component({
    selector: 'ateco-edit-form',
    templateUrl: './ateco-edit-form.component.html',
    styleUrls: ['./ateco-edit-form.component.scss'],
})
export class AtecoEditFormComponent implements OnInit {
    _atecoForEditing: AtecoUtente;
    _forfettarioAtecoUtente: AtecoUtente[];

    ateco: Ateco[];

    @Input()
    set atecoForEditing(value: AtecoUtente) {
        this._atecoForEditing = value;
        this.buildForm();
    }

    @Input()
    set forfettarioAtecoUtente(value: AtecoUtente[]) {
        this._forfettarioAtecoUtente = value;
        this.buildForm();
    }

    get atecoForEditing() {
        return this._atecoForEditing;
    }

    get forfettarioAtecoUtente() {
        return this._forfettarioAtecoUtente;
    }

    @Input()
    atecoEditFormBuildOptions: AtecoEditFormBuildOptions = { dataInizioDisabled: true, dataFineDisabled: true };

    @Input()
    showAtecoEditForm: boolean = false;

    @Output()
    salvaAtecoEdited: EventEmitter<AtecoUtente> = new EventEmitter<AtecoUtente>();

    @Output()
    annullaAtecoEdited: EventEmitter<void> = new EventEmitter<void>();

    atecoEditForm: FormGroup;

    constructor(private formBuilder: FormBuilder, private commonService: CommonService) {}

    get descrizioneOriginaleAteco() {
        return this.ateco?.find(x => x.id === this.atecoForEditing.atecoid)?.descrizione;
    }

    get descrizionePersonalizzataAteco() {
        return this.forfettarioAtecoUtente?.find(x => x.atecoid === this.atecoForEditing.atecoid)?.descrizione;
    }

    ngOnInit(): void {
        this.commonService.ateco$
            .pipe(
                tap(ateco => (this.ateco = ateco)),
                take(1)
            )
            .subscribe();

        this.buildForm();
    }

    saveAteco() {
        const atecoEdited: AtecoUtente = {
            id: this.atecoForEditing.id,
            atecoid: this.atecoForEditing.atecoid,
            descrizione: this.atecoEditForm.get('descrizionePersonalizzata').value,
            dataInizio: this.atecoEditForm.get('dataInizio').value,
            dataFine: this.atecoEditForm.get('dataFine').value,
        };

        this.salvaAtecoEdited.emit(atecoEdited);
    }

    buildForm() {
        this.atecoEditForm = this.formBuilder.group({
            descrizionePersonalizzata: [this.descrizionePersonalizzataAteco ?? null],
            dataInizio: [{ value: this.atecoForEditing.dataInizio, disabled: this.atecoEditFormBuildOptions.dataInizioDisabled }, Validators.required],
            dataFine: [{ value: this.atecoForEditing.dataFine, disabled: this.atecoEditFormBuildOptions.dataFineDisabled }],
        });
    }

    annullaAteco() {
        this.atecoEditForm.reset();
        this.annullaAtecoEdited.emit();
    }
}
